import React from 'react';

interface FloatingPanelCardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
  role?: React.AriaRole;
  'aria-label'?: string;
}

export function FloatingPanelCard({
  children,
  className = '',
  style,
  id,
  role,
  'aria-label': ariaLabel,
}: FloatingPanelCardProps) {
  return (
    <div
      id={id}
      role={role}
      aria-label={ariaLabel}
      className={`floating-panel floating-panel-card rounded-2xl border border-brand-border/80 p-4 text-(--color-text) shadow-[0_20px_50px_rgba(0,0,0,0.35)] ${className}`.trim()}
      style={style}
    >
      {children}
    </div>
  );
}
